module.exports = __webpack_public_path__ + "static/media/sliderimg1.fb922c87.webp";